<template>
  <div class="row">
    <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4">
      <fg-input
        type="text"
        :label="`${$t('common_words.name')}: `"
        v-model="model.name"
        name="common_words.name"
        v-validate="modelValidations.name"
        :error="getError('common_words.name', true)"
        placeholder="..."
      >
      </fg-input>
    </div>
    <div class="col-12 col-sm-6 col-md-8 col-lg-6 col-xl-8">
      <div class="form-group has-label">
        <label>{{ $t('common_words.modules') }}: *</label>
        <br />
        <el-select
          @change="selectAllFromSelect('model.modules_id', modules)"
          collapse-tags
          clearable
          filterable
          multiple
          class="select-primary custom-width-select shadow-sm required-modules"
          size="large"
          v-model="model.modules_id"
          :placeholder="`${$t('common_words.select')}...`"
        >
          <el-option
            v-for="(option, index) in modules"
            class="select-primary selected-all"
            :value="option.id"
            :label="option.name"
            :key="index + option.id"
          ></el-option>
        </el-select>
      </div>
    </div>
    <div class="col-12">
      <select-businesses-component
        ref="selectBusiness"
        :requiered="true"
        :initialData="businessesInitial"
        @onChange="updateSelectedBusinesses"
        @showHideLoading="showHideLoading"
      />
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util';
import Businesses from 'src/components/Selects/Businesses.vue';
import i18n from 'src/i18n';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations.js';
export default {
  components: {
    [Businesses.name]: Businesses,
  },
  data() {
    return {
      businessesInitial: [],
      businesses: [],
      modules: [],
      model: {
        id: null,
        name: null,
        businesses_id: [],
        businesses_names: [],
        modules_id: [],
        modules_names: [],
      },
      modelValidations: {
        name: { required: true },
      },
    };
  },
  watch: {
    '$i18n.locale': ['getSelectAll'],
  },
  mixins: [
    MixinPermissions,
    MixinForm,
    MixinAlert,
    MixinLoading,
    MixinValidations,
  ],
  methods: {
    getSelectAll() {
      this.modules = this.concatAll(this.modules.splice(1));
    },
    updateSelectedBusinesses(data) {
      const bsSelected = data.associations_ids.concat(data.businesses_ids);
      this.$set(this.model, 'businesses_id', bsSelected);
      this.$set(this.model, 'businesses_names', data.names);
    },
    getNameOfData(dataMain, options) {
      const others = [];
      dataMain.forEach((element) => {
        const isFind = options.find((item) => item.id === element);
        if (isFind) others.push(isFind.name);
      });

      return others;
    },
    validate() {
      return this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (!isset(this.model.modules_id)) {
            return this.validationInputsRequired('modules');
          } else if (!isset(this.model.businesses_id)) {
            return this.validationInputsRequired('bus-rels');
          }
          this.model.modules_names = this.getNameOfData(
            this.model.modules_id,
            this.modules
          );
          this.$emit('on-validated', this.model);

          return isValid;
        }
      });
    },
  },
  mounted() {
    this.showHideLoading(true);
    if (this.isCreate() || this.isUpdate()) {
      Axios.getMasters('modules/indexlevel3')
        .then((response) => {
          this.modules = this.concatAll(response.data.data);
          const editForm = sessionStorage.getItem('editForm');
          if (this.isUpdate() && editForm) {
            const { id, name, modules } = JSON.parse(editForm);
            this.model = {
              ...this.model,
              id,
              name,
              modules_id: modules.map((module) => module.id),
            };
            const { business, businesses } = editForm;
            this.$set(
              this,
              'businessesInitial',
              businesses ? businesses : business
            );
            sessionStorage.removeItem('editForm');
          }
        })
        .catch((error) => this.showMessageErrors(error));
      // this.showHideLoading();
      setTimeout(() => {
        this.showHideLoading();
      }, 1500);
    } else this.showHideLoading();
  },
  updated() {
    if (
      this.businesses &&
      this.businesses.length === 1 &&
      this.model.businesses_id.length === 0
    ) {
      this.model.businesses_id.push(this.businesses[0].id);
    }
  },
};
</script>
